module.exports = __webpack_public_path__ + "img/solution-pc-1.56773a10.png";